import React from "react";
import Radium from "radium";
import { Link } from "react-router";
import { Paper, RaisedButton, FlatButton } from "material-ui";
import Avatar from "react-avatar";

import * as util from "../util";

import WorkingIndicator from "./partials/working-indicator.jsx";

import Notes from "./partials/notes/notes.jsx";
import PassTable from "./partials/pass-table.jsx";
import TicketTable from "./partials/ticket-table.jsx";
import OrderTable from "./partials/order-table.jsx";
import LinkLike from "./partials/link-like.jsx";
import EditPersonOverlay from "./partials/overlays/edit-person.jsx";
import PersonLatestInfo from "./partials/person-latest-info.jsx";
import CreditsWidget from "./partials/credits-widget.jsx";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonActions from "../actions/PersonActions";
import PersonStore from "../stores/PersonStore";
import PassActions from "../actions/PassActions";
import PassStore from "../stores/PassStore";
import TicketActions from "../actions/TicketActions";
import TicketStore from "../stores/TicketStore";
import OrderActions from "../actions/OrderActions";
import OrderStore from "../stores/OrderStore";
import EventBucketStore from "../stores/EventBucketStore";
import UserStore from "../stores/UserStore";
import GodActions from "../actions/GodActions";

const BUCKET_VIEW_ALL = "view_all";

class Person extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFetchingPerson: false,
      fetchedPerson: null,
      showEditor: false
    };
  }

  static getStores() {
    return [PersonStore, PassStore, TicketStore, OrderStore, EventBucketStore];
  }

  static getPropsFromStores() {
    return {
      getPersonById: PersonStore.getPersonById,
      getPassesForPerson: PassStore.getPassesForPerson,
      getTicketsForPerson: TicketStore.getTicketsForPerson,
      getOrdersForPerson: OrderStore.getOrdersForPerson,
      getEventBucketById: EventBucketStore.getEventBucketById
    };
  }

  static get contextTypes() {
    return {
      router: React.PropTypes.object
    };
  }

  getStyles() {
    return {
      content: {
        display: "flex"
      },
      sidebar: {
        minWidth: 336,
        maxWidth: 336,
        padding: "0 2px",
        marginRight: 22
      },
      sidebarInner: {
        paddingBottom: "1em"
      },
      main: {
        flex: 1
      }
    };
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  componentWillReceiveProps(newProps) {
    var person = newProps.getPersonById(newProps.params.personId);

    if (
      !this.state.isFetchingPerson &&
      this.state.fetchedPerson !== newProps.params.personId
    ) {
      this.setState({ isFetchingPerson: true });
      PersonActions.fetchOne(newProps.params.personId);
      PassActions.fetchAllForPerson(newProps.params.personId);
      TicketActions.fetchAllForPerson(newProps.params.personId);
      OrderActions.fetchAllForPerson(newProps.params.personId);
    } else if (person) {
      this.setState({ isFetchingPerson: false, fetchedPerson: person.id });
    }
  }

  render() {
    var styles = this.getStyles(),
      currentEventBucket = this.props.params.eventBucketId, // restrict to a single event bucket
      person = this.props.getPersonById(this.props.params.personId),
      passes = this.props.getPassesForPerson(
        this.props.params.personId,
        currentEventBucket
      ),
      tickets = this.props.getTicketsForPerson(
        this.props.params.personId,
        currentEventBucket
      ),
      orders = this.props.getOrdersForPerson(
        this.props.params.personId,
        currentEventBucket
      );

    if (!person || this.state.isFetchingPerson) {
      return <WorkingIndicator fullPage />;
    }

    let bucketOptions = [BUCKET_VIEW_ALL].concat(person.event_buckets),
      selectedBucketOption = currentEventBucket || BUCKET_VIEW_ALL;

    // In case someone logs in but never orders - fallback event bucket to place their
    // "New Box Office Order" from
    let fallbackEventBucketId;
    if (!this.props.params.eventBucketId) {
      let allBuckets = EventBucketStore.getEventBuckets();
      fallbackEventBucketId = allBuckets.length ? allBuckets[0].id : undefined;
    }

    let eventBucketIdForSidebar =
      this.props.params.eventBucketId ||
      person.event_buckets[person.event_buckets.length - 1] ||
      fallbackEventBucketId;

    let showCredits =
      currentEventBucket &&
      (EventBucketStore.getEventBucketById(currentEventBucket) || {})
        .credits_enabled;

    // Needed for isSundance check
    let fullEventBucket = EventBucketStore.getEventBucketById(currentEventBucket);

    let isMembership = false;
    if (fullEventBucket) {
      isMembership = fullEventBucket.frontend_config.memberships_enabled;
    }

    return (
      <div style={styles.content}>
        {this.state.showEditor ? (
          <EditPersonOverlay
            onRequestClose={() => this.setState({ showEditor: false })}
            details={person.details}
            onEdit={(data, opts) => {
              PersonActions.edit(person.id, data);
              if (!opts || !opts.doNotClose) {
                this.setState({ showEditor: false });
              }
            }}
          />
        ) : null}

        <div style={styles.sidebar}>
          <div style={styles.sidebarInner}>
            <Avatar
              style={{ margin: "0 auto", display: "block" }}
              name={person.details.name || person.details.email}
              facebookId={person.details.facebook_user_id}
              size={100}
              round={true}
            />
            <h1
              style={{
                lineHeight: 1,
                textAlign: "center",
                overflowWrap: "break-word"
              }}
            >
              {person.details.name ? person.details.name : person.details.email}
            </h1>
            <div>
              <div>
                <strong>Name:</strong> {person.details.name || "None provided"}
              </div>
              <div>
                <strong>Email:</strong>{" "}
                <a href={`mailto:${person.details.email}`}>
                  {person.details.email}
                </a>
              </div>
              {person.details.sundance_user_id ? (
                <div>
                  {person.details.sundance_user_id === "__SHADOW__" ? (
                    <div
                      style={{
                        background: "red",
                        padding: "0 2px",
                        color: "#fff",
                        lineHeight: "1.25em",
                        padding: 5,
                        borderRadius: "0.25em",
                        margin: "5px 0"
                      }}
                    >
                      <strong>User has not yet logged in:</strong> Not yet
                      connected to a Sundance SSO account. User must login with
                      the above email to claim access.
                    </div>
                  ) : (
                    <div>
                      <strong>Sundance user ID:</strong>{" "}
                      {person.details.sundance_user_id || "None provided"}
                    </div>
                  )}
                  <div>
                    <strong>Password:</strong> No password &ndash; login with
                    Sundance
                  </div>
                </div>
              ) : person.details.cannes_accreditation_id ? (
                <div>
                  <div>
                    <strong>Cannes accreditation ID:</strong>{" "}
                    {person.details.cannes_accreditation_id || "None provided"}
                  </div>
                  <div>
                    <strong>Password:</strong> No password &ndash; login with
                    Cannes
                  </div>
                </div>
              ) : person.details.eventival_person_id ? (
                <div>
                  <div>
                    <strong>Eventival person ID:</strong>{" "}
                    {person.details.eventival_person_id || "None provided"}
                  </div>
                  <div>
                    <strong>Password:</strong> No password &ndash; login with
                    Eventival
                  </div>
                </div>
              ) : person.details.ida_user_id ? (
                <div>
                  <div>
                    <strong>MyIDA account ID:</strong>{" "}
                    {person.details.ida_user_id || "None provided"}
                  </div>
                  <div>
                    <strong>Password:</strong> No password &ndash; login with
                    IDA
                  </div>
                </div>
              ) : person.details.whitelabel_user_id ? (
                <div>
                  <strong>Password:</strong> No password &ndash; whitelabel
                  integration
                </div>
              ) : person.details.aarp_user_id ? (
                <div>
                  <strong>Password:</strong> No password &ndash; login with AARP
                </div>
              ) : (
                <div>
                  <strong>Password:</strong> •••••• (
                  <LinkLike
                    onTouchTap={() =>
                      window.confirm(
                        `Are you sure you would like to send a password reset link to "${person.details.email}"?`
                      ) &&
                      PersonActions.forgotPassword({
                        id: person.id,
                        event_bucket: eventBucketIdForSidebar
                      })
                    }
                  >
                    email password reset link
                  </LinkLike>
                  )
                </div>
              )}
              <div>
                <strong>Payment method:</strong>{" "}
                {person.details.payment_method_summary || "None set"}
              </div>
              {/*<div><strong>Customer ID:</strong> {person.id.toUpperCase()}</div>*/}
              <div style={{ marginTop: "0.5em", whiteSpace: "nowrap" }}>
                <FlatButton
                  primary={true}
                  onTouchTap={() => this.setState({ showEditor: true })}
                  label="Edit details"
                  style={{
                    border: "1px solid",
                    verticalAlign: -1,
                    marginRight: 7
                  }}
                  labelStyle={{ verticalAlign: "0px" }}
                />
                <RaisedButton
                  label="New box office order"
                  primary={true}
                  onTouchTap={() =>
                    this.context.router.push({
                      pathname: `/event_buckets/${eventBucketIdForSidebar}/box_office`,
                      query: { person: person.id }
                    })
                  }
                />
              </div>
            </div>
            <div>
              <Paper
                zDepth={1}
                style={{
                  marginTop: "1em",
                  marginBottom: "1em",
                  padding: 10,
                  textAlign: "left"
                }}
              >
                <PersonLatestInfo personId={person.id} />
              </Paper>
            </div>
            <h2>Notes</h2>
            <Notes person={person.id} />
          </div>
        </div>

        <div style={styles.main}>
          {person.event_buckets.length ? (
            <div>
              {bucketOptions.map(b => {
                let bucket = this.props.getEventBucketById(b) || {},
                  name =
                    b === BUCKET_VIEW_ALL
                      ? "View all"
                      : bucket.name || "Deleted event bucket";

                return selectedBucketOption === b ? (
                  <FlatButton
                    style={{
                      border: "1px solid #ccc",
                      backgroundColor: "#ccc",
                      color: "#fff",
                      marginRight: 5,
                      marginTop: "5px"
                    }}
                    labelStyle={{ verticalAlign: 0 }}
                    label={name}
                    disabled={true}
                  />
                ) : (
                  <Link
                    to={
                      b === BUCKET_VIEW_ALL
                        ? `/people/${person.id}`
                        : `/event_buckets/${b}/people/${person.id}`
                    }
                  >
                    <FlatButton
                      label={name}
                      style={{
                        border: "1px solid",
                        marginTop: "5px",
                        marginRight: 5
                      }}
                      labelStyle={{ verticalAlign: 0 }}
                    />
                  </Link>
                );
              })}
            </div>
          ) : null}
          {showCredits ? (
            <div>
              <CreditsWidget
                showHeader={true}
                headerStyle={{ marginTop: 25 }}
                person={person.id}
                eventBucket={currentEventBucket}
              />
            </div>
          ) : null}
          <h2 style={{ marginTop: 25 }}>Passes</h2>
          <PassTable
            passes={passes.filter(pass => !pass.pass_bucket.is_membership)}
            person={person.details}
            isSinglePerson={true}
            eventBucket={passes.length && passes[0].event_bucket}
            isSundance={fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.sundance_login : false}
            showTransferHistory={fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.enable_transfer_history : false}
            location={this.props.location}
          />
          {isMembership &&
            <div>
              <h2 style={{ marginTop: 25 }}>Memberships</h2>
              <PassTable
                passes={passes.filter(pass => pass.pass_bucket.is_membership)}
                person={person.details}
                isSinglePerson={true}
                eventBucket={passes.length && passes[0].event_bucket}
                isSundance={fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.sundance_login : false}
                location={this.props.location}
                isMemberships
              />
            </div>
        }
          <h2 style={{ marginTop: 25 }}>Tickets</h2>
          <TicketTable
            tickets={tickets}
            eventBucket={this.props.params.eventBucketId}
            isSundance={fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.sundance_login : false}
            showTransferHistory={fullEventBucket && fullEventBucket.frontend_config ? fullEventBucket.frontend_config.enable_transfer_history : false}
            person={person.id}
            showEvent={true}
            location={this.props.location}
          />
          <h2 style={{ marginTop: 25 }}>Orders</h2>
          <OrderTable
            orders={orders}
            eventBucket={this.props.params.eventBucketId}
            isSinglePerson={true}
          />
        </div>

        {UserStore.isGod() ? (
          <div style={{ position: "absolute", right: 0, top: 0 }}>
            <LinkLike
              style={{ color: "#fff" }}
              onTouchTap={() => GodActions.becomePerson(person.id)}
            >
              [1]
            </LinkLike>
          </div>
        ) : null}
      </div>
    );
  }
}

export default Radium(connectToStores(Person));



// WEBPACK FOOTER //
// ./src/app/components/person.jsx